/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueUtils } from "abreact/data/AbDataValueUtils";
import { isCollectionAccessor } from "abreact/data/DataValueAccessor";
import { DataValueViews } from "abreact/data/DataValueViews";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import * as React from "react";
export function AbDataValueRenderer(props) {
  if (props.subject == null) {
    return null;
  }
  const viewProvider = DataValueViews.getViewProvider(props.dataType ?? props.accessor.dataType);
  const isModified = AbDataValueUtils.isDataValueModified(props.subject, props.accessor);
  const isCollection = isCollectionAccessor(props.accessor);
  const componentProps = ReactUtils.componentProps("ab-data-value-renderer", props, [isModified && "ab-is-modified", isCollection && "ab-is-collection"]);
  return /*#__PURE__*/React.createElement("div", componentProps, viewProvider.renderValue(props));
}
//# sourceMappingURL=AbDataValueRenderer.js.map
